import { bindActionCreators } from 'redux'

import { getPaymentConfirmation, getInvoices } from 'reduxpath/ducks/Project/PaymentConfirmation'

import Home from 'units/PaymentConfirmation'
import List from 'units/PaymentConfirmation/units/List'

function list(store) {
  const actions = bindActionCreators({
    getPaymentConfirmation,
    getInvoices,
  }, store.dispatch)
  const qs = {
    sort: 'createdAt ASC',
    limit: 10,
    skip: 0,
  }
  actions.getInvoices(
    {
      status: store.getState().Reference.invoiceStatus.waitingConfirmation.status,
    },
    qs,
  )
  actions.getPaymentConfirmation(qs)
}

export default {
  populate: {
    list,
  },
  components: {
    Home,
    List,
  },
}
